export default __webpack_public_path__ + "static/media/logo.f2a608c6.png";